<template>
  <caption class="columns loadingAnimation">
    <div class="column loader-wrapper">
      <b-icon
        custom-class="fa-spin"
        icon="spinner"
        pack="fas"
        :size="size"
      />
    </div>
  </caption>
</template>

<script lang="ts">
import { BIcon } from "buefy";

export default {
  name: "LoadingAnimate",
  components: { BIcon },
  props: {
    size: {
      type: String,
      required: true,
    },
  },
  emits: ["changedStatusLoading"],
};
</script>
